import styled from "styled-components";
import { colors } from "../../../../../../consts";

export const Label = styled.label`
  font-size: 14px;
  line-height: 14px;
  font-weight: 500;
  margin-bottom: 8px;

  color: ${colors.RAISIN_100};
`;

export const CheckboxLabel = styled.label`
  font-size: 16px;
  line-height: 24px;
  font-weight: 400;
  color: ${colors.RAISIN_80};
  cursor: pointer;

  ${(props) => props.disabled && "pointer-events: none"};
`;
